// 全局视频播放器开关（单例）。任意页 useVideoPlayer().open(fileUrl, title) 弹出播放器。
// 播放 HLS(.m3u8)：Safari 原生支持，其他浏览器动态加载 hls.js。
import { ref } from "vue";

const visible = ref(false);
const src = ref("");
const title = ref("");

export function useVideoPlayer() {
  function open(fileUrl?: string, videoTitle = "") {
    if (!fileUrl) return;
    // 站点是 https，视频源常是 http（阿里云 OSS）→ 升级避免混合内容被拦
    src.value = fileUrl.replace(/^http:\/\//i, "https://");
    title.value = videoTitle;
    visible.value = true;
  }
  function close() {
    visible.value = false;
    src.value = "";
    title.value = "";
  }
  return { visible, src, title, open, close };
}
